import React from 'react';
import { Sparkles } from 'lucide-react';
import PriceDisplay from './PriceDisplay';
import {
  PricingCardContainer,
  PricingBadge,
  PricingHeader,
  PricingName,
  PricingFeatures,
  PricingFeature,
  FeatureBadge,
  PricingButton,
  UrgencyBadge
} from './styles';

interface PricingCardProps {
  featured?: boolean;
  badge?: string;
  name: string;
  // Props comuns
  currencySymbol: string;
  billing: string;
  features: string[];
  onSubscribe: () => void;
  ctaText: string;
  urgencyIcon: React.ReactNode;
  urgencyText: string;
  isDisabled: boolean;
  sparklesFeatureIndex?: number;
  // Props específicas por tipo
  isMonthly?: boolean;
  price?: string;
  paymentInfo?: string;
  // Props para parcelado (trimestral/anual)
  installmentPrefix?: string;
  installmentValue?: string;
  installmentSuffix?: string;
  cashLabel?: string;
  cashPrice?: string;
  cashSuffix?: string;
}

const PricingCard: React.FC<PricingCardProps> = ({
  featured = false,
  badge,
  name,
  currencySymbol,
  billing,
  features,
  onSubscribe,
  ctaText,
  urgencyIcon,
  urgencyText,
  isDisabled,
  sparklesFeatureIndex,
  isMonthly = false,
  price = '',
  paymentInfo = '',
  installmentPrefix,
  installmentValue,
  installmentSuffix,
  cashLabel,
  cashPrice,
  cashSuffix
}) => {
  return (
    <PricingCardContainer $featured={featured} data-plan={featured ? "enterprise" : undefined}>
      {badge && <PricingBadge>{badge}</PricingBadge>}

      <PricingHeader>
        <PricingName>{name}</PricingName>
        <PriceDisplay
          isMonthly={isMonthly}
          currencySymbol={currencySymbol}
          price={price}
          billing={billing}
          paymentInfo={paymentInfo}
          installmentPrefix={installmentPrefix}
          installmentValue={installmentValue}
          installmentSuffix={installmentSuffix}
          cashLabel={cashLabel}
          cashPrice={cashPrice}
          cashSuffix={cashSuffix}
        />
      </PricingHeader>

      <PricingFeatures>
        {features.map((feature, index) => (
          sparklesFeatureIndex !== undefined && index === sparklesFeatureIndex ? (
            <li key={index} style={{ marginBottom: '12px' }}>
              <FeatureBadge><Sparkles /> {feature}</FeatureBadge>
            </li>
          ) : (
            <PricingFeature key={index}>{feature}</PricingFeature>
          )
        ))}
      </PricingFeatures>

      <PricingButton onClick={onSubscribe} disabled={isDisabled}>
        {ctaText}
      </PricingButton>

      <UrgencyBadge>
        {urgencyIcon} {urgencyText}
      </UrgencyBadge>
    </PricingCardContainer>
  );
};

export default PricingCard;
